// Copied from the Toolkit (shared/ui/Field.tsx).
import { useId, type CSSProperties, type ReactNode } from 'react';

// A labelled field: <Field label="Title">{(id) => <input id={id} />}</Field>. The label comes first and the control right after it,
// the way the style sheet lays them out.
export function Field({ label, children, hint, className = 'field', style }: { label: ReactNode; children: (id: string) => ReactNode; hint?: ReactNode; className?: string; style?: CSSProperties }) {
  const id = useId();
  return <div className={className} style={style}><label htmlFor={id}>{label}</label>{children(id)}{hint && <div className="hint">{hint}</div>}</div>;
}

// A checkbox with its label to the right.
export function Toggle({ label, checked, defaultChecked, onChange, disabled, name, style }: { label: ReactNode; checked?: boolean; defaultChecked?: boolean; onChange?: (v: boolean) => void; disabled?: boolean; name?: string; style?: CSSProperties }) {
  const id = useId();
  return (
    <div className="toggle-row" style={style}>
      <input type="checkbox" id={id} name={name} checked={checked} defaultChecked={defaultChecked} disabled={disabled} onChange={(e) => onChange?.(e.target.checked)} />
      <label htmlFor={id}>{label}</label>
    </div>
  );
}
